import { useDispatch } from 'react-redux';

export type AppDispatch = any;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
